import styled from 'styled-components'

export const LicenceHelperStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .helper-text {
    max-width: 354px;
  }
  .helper-image {
    max-width: 354px;
    height: auto;
  }
`
